import React, { useState } from 'react';
import Button from '../../../../components/UI/Button/Button';
import Modal from '../../../../components/UI/Modal/Modal';
import BenchmarkQuestionForm from './BenchmarkQuestionForm';
import { BenchmarkQuestion } from '../../../../store/benchmark/types';
import { createBenchmarkQuestion } from '../../../../api/benchmarkApi';

interface CreateBenchmarkQuestionProps {
  onQuestionCreated: () => void;
}

const CreateBenchmarkQuestion: React.FC<CreateBenchmarkQuestionProps> = ({ onQuestionCreated }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCreate = async (values: Partial<BenchmarkQuestion>) => {
    try {
      await createBenchmarkQuestion(values);
      setIsModalOpen(false);
      onQuestionCreated();
    } catch (err) {
      console.error('Error creating question:', err);
    }
  };

  return (
    <>
      <Button onClick={() => setIsModalOpen(true)}>Create Question</Button>

      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Create Benchmark Question"
      >
        <BenchmarkQuestionForm onSubmit={handleCreate} onCancel={() => setIsModalOpen(false)} />
      </Modal>
    </>
  );
};

export default CreateBenchmarkQuestion;
